import {
  DisbursementReasonCategory,
  GetBatchDisbursementsQuery,
  GetEmployeeDisbursementsQuery,
  GetProviderDisbursementsQuery,
} from "generated/graphql";

export enum DisbursementStatus {
  unprocessed = "unprocessed",
  paid = "paid",
  failed = "failed",
  pendingApproval = "pending_approval",
  rejected = "rejected",
}

export const disbursementStatusDictionary: {
  [value in DisbursementStatus]: string
} = {
  [DisbursementStatus.unprocessed]: "Processing",
  [DisbursementStatus.paid]: "Sent",
  [DisbursementStatus.failed]: "Failed",
  [DisbursementStatus.pendingApproval]: "Pending Approval",
  [DisbursementStatus.rejected]: "Rejected",
};

export const disbursementReasonDictionary: {
  [value in DisbursementReasonCategory]: string
} = {
  [DisbursementReasonCategory.Bonus]: "Bonus",
  [DisbursementReasonCategory.DirectDepositReplacement]:
    "Direct Deposit Replacement",
  [DisbursementReasonCategory.MissingHoursPto]: "Missing Hours/PTO",
  [DisbursementReasonCategory.PapercheckReplacement]: "Paper Check Replacement",
  [DisbursementReasonCategory.Termination]: "Termination",
  [DisbursementReasonCategory.Tips]: "Tips",
  [DisbursementReasonCategory.Other]: "Other",
};

export type DPEmployeeDisbursement = GetEmployeeDisbursementsQuery["employeeProfile"]["disbursements"]["items"][0];

export type DPProviderDisbursement = NonNullable<GetProviderDisbursementsQuery["disbursements"]>["items"][0];

export type DPBatchDisbursement = NonNullable<GetBatchDisbursementsQuery["batchDisbursements"]>["items"][0]
